import styled from 'styled-components'

export const ModalBodyWrapper = styled.div`
  font-size: 15px;
  font-weight: 400;
  padding: 20px;
  max-width: 400px;
`
